/*
 * Copyright (c) 2026 Centrica.  All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * Date: 2026-09-30
 */
import { Injectable, inject, signal } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs';

/**
 * Cuantas peticiones al servidor siguen en curso.
 *
 * <p>La base del CRUD lo usa para saber cuando llego el registro que se abrio en editar o
 * consultar, sin depender de como lo trae cada pantalla: por el store, por su servicio o en
 * varias peticiones encadenadas.</p>
 */
@Injectable({ providedIn: 'root' })
export class PeticionesEnCursoService {
  private readonly cuenta = signal(0);

  /** Peticiones en curso. */
  readonly enCurso = this.cuenta.asReadonly();

  /** Una peticion salio. */
  empezo(): void {
    this.cuenta.update((n) => n + 1);
  }

  /** Una peticion termino, bien o mal. */
  termino(): void {
    this.cuenta.update((n) => Math.max(0, n - 1));
  }
}

/** Cuenta cada peticion mientras esta en curso. */
export const peticionesEnCursoInterceptor: HttpInterceptorFn = (req, next) => {
  const peticiones = inject(PeticionesEnCursoService);
  peticiones.empezo();
  return next(req).pipe(finalize(() => peticiones.termino()));
};
